import React, { useEffect, useState } from "react";
import logo from "./images/logo.svg";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer.jsx";
import styles from "./css/helper.module.scss";
const yaml = require("js-yaml");

const baseUrl = "https://tool.yunqiboyuan.com/";
const timestamp = new Date().getTime();
const ymlUrl = `${baseUrl}upload/appversion/latest.yml?v=${timestamp}`;
const PageDetails = () => {
    window.scrollTo(0, 0);
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    };
    const index = window.location.search.split("=")[1];
    console.log(index, "**************************")
    const [app_name, setApp_name] = useState("");
    const [downloadUrl, setDownloadUrl] = useState("");
    useEffect(() => {
        fetchAndParseYaml(ymlUrl);
    }, []);

    async function fetchAndParseYaml(url) {
        console.log("url", url);
        try {
            // 发送 HTTP GET 请求获取 YAML 文件内容
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data = await response.text();
            // 解析 YAML 内容
            const config = yaml.load(data);
            // 读取并打印 path 字段
            const filePath = config?.path;
            console.log("Path:", filePath);
            setDownloadUrl(`${baseUrl}upload/appversion/${filePath}`);
            setApp_name(filePath);
        } catch (e) {
            console.error("读取或解析 YAML 文件时出错:", e);
        }
    }
    const download = () => {
        console.log(" downloadUrl", downloadUrl);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = app_name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div>
            <header className={styles.header}>
                <div className={styles.logo}>
                    <img src={logo} title="logo" />
                </div>
                <div className={styles.nav}>
                    <span style={{ marginRight: '45px' }} onClick={() => handleNavigate("/")}>首页</span>
                    <span style={{ color: "#ff4338", marginRight: '45px' }} onClick={() => handleNavigate("/helper")}>使用帮助</span>
                    <span onClick={() => handleNavigate("/about")}>关于我们</span>
                </div>
            </header>

            <div className={styles.pageMain}>


                <div className={styles.container}>
                    <div className={styles.style1}>
                        <h2 className={styles.style2}>云启zip解压缩工具</h2>
                        <p className={styles.style3} >一款快速解压各类文件，支持多种格式文件压缩的专业解压缩工具！</p>
                        <div onClick={() => download()} className={styles.style4}>
                            <strong>立即下载ZIP压缩工具</strong>
                            <span className={styles.style5}>适用系统：WinAll</span>
                        </div>
                    </div>

                    <div hidden={index != 1}>
                        <div className={styles.intro}>ZIP压缩包打不开？这篇文章手把手教你如何快速排查并解决问题。</div>
                        <h1>ZIP压缩包打不开？教你5步解决常见问题</h1>
                    </div>

                    <div hidden={index != 2}>
                        <div className={styles.intro}>经常下载一堆压缩包？教你一键批量解压的方法，简单又高效。</div>
                        <h1>如何一键批量解压多个压缩文件？</h1>
                    </div>

                    <div hidden={index != 3}>
                        <div className={styles.intro}>文件解压失败总是烦人，看看你是否遇到了这些常见问题。</div>
                        <h1>解压失败是什么原因？附解决办法大全</h1>
                    </div>

                    <div hidden={index != 4}>
                        <div className={styles.intro}>了解云启Zip支持的主流压缩格式，从此告别格式不兼容的烦恼。</div>
                        <h1>云启Zip支持哪些格式？压缩解压全兼容解析</h1>
                    </div>

                    <div hidden={index != 5}>
                        <div className={styles.intro}>解压像蜗牛？试试这几招，大幅提升文件解压速度。</div>
                        <h1>解压速度太慢怎么办？这5招帮你提速</h1>
                    </div>

                    <div hidden={index != 6}>
                        <div className={styles.intro}>遇到加密压缩包却忘记密码？别慌，这里有应对方法。</div>
                        <h1>加密压缩包忘记密码？看看这几种应对方案</h1>
                    </div>

                    <div hidden={index != 7}>
                        <div className={styles.intro}>压缩格式这么多，WinRAR和ZIP到底有什么区别？该用哪个？</div>
                        <h1>WinRAR和ZIP格式有什么区别？怎么选？</h1>
                    </div>

                    <div hidden={index != 8}>
                        <div className={styles.intro}>7z格式不会解压？这篇教程一步一步教你搞定。</div>
                        <h1>怎么解压7z文件？详细图文教程来了</h1>
                    </div>

                    <div hidden={index != 9}>
                        <div className={styles.intro}>挑选解压工具不知道选哪个？看看云启Zip的实际表现。</div>
                        <h1>电脑解压工具哪个好？云启Zip真实测评</h1>
                    </div>

                    <div hidden={index != 10}>
                        <div className={styles.intro}>处理重要文件时你最需要的，是一个真正安全可靠的本地解压工具。</div>
                        <h1>云启Zip安全吗？本地解压 + 无上传机制详解</h1>
                    </div>

                    <div className={styles.flexTextCon}>
                        <div className={styles.flexLeftCon}>
                            <span className={styles.flexNum}>1</span>
                            <span className={styles.flexLine}></span>
                            <span className={styles.flexNum}>2</span>
                            <span className={styles.flexLine}></span>
                            <span className={styles.flexNum}>3</span>
                            <span className={styles.flexLine}></span>
                            <span className={styles.flexNum}>4</span>
                            <span className={styles.flexLine}></span>
                            <span className={styles.flexNum}>5</span>
                            <span className={styles.flexNoLine}></span>
                        </div>
                        <div className={styles.flexRightCon}>
                            <h2>常见问题原因分析</h2>
                            <p className={styles.textP}>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>

                            <h2>工具使用建议</h2>
                            <p className={styles.textP}>选择支持多格式、支持多线程、纯本地运行的工具，如云启Zip，可以避免大多数解压问题。</p>

                            <h2>安全性与速度优化</h2>
                            <p className={styles.textP}>云启Zip支持本地解压，无需上传，保障隐私。同时也针对ZIP/RAR/7Z格式做了性能优化。</p>

                            <h2>实用技巧补充</h2>
                            <p className={styles.textP}>批量解压、多路径指定、右键菜单集成……这些功能也能大幅提升办公效率。</p>

                            <h2>总结</h2>
                            <p className={styles.textP}>找对工具，解决95%的压缩解压烦恼。赶紧试试云启Zip！</p>
                        </div>
                    </div>


            
                </div>

            </div>


            <Footer />
        </div>
    );
};

export default PageDetails;
